module.exports = __webpack_public_path__ + "img/nft.3ab297d4.svg";